import React from 'react';
import {
  Alert,
  Box,
  Card,
  CardContent,
  Chip,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Typography,
} from '@mui/material';
import { PersonAddAlt, Visibility, VisibilityOff } from '@mui/icons-material';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import JumboTextField from '@jumbo/components/JumboFormik/JumboTextField';
import JumboSelectField from '@jumbo/components/JumboFormik/JumboSelectField';
import CircularProgress from '@mui/material/CircularProgress';
import { COUNTRIES } from 'app/utils/constants/countries';

const FormularioResponsavelNovo = ({
  values,
  setFieldValue,
  handleChange,
  precisaResponsavel,
  responsavelEncontrado,
  confirmedUserData,
  isLoading,
  mostrarSenhaResponsavel,
  mostrarSenhaConfirmacaoResponsavel,
  handleClickShowSenhaResponsavel,
  handleClickShowSenhaConfirmacaoResponsavel,
  handleMouseDownPassword,
  handleMouseDownPasswordConfirmation,
  checkCepResp,
}) => {
  if (!precisaResponsavel || responsavelEncontrado) return null;

  return (
    <Card variant='outlined' sx={{ mb: 3, borderColor: 'warning.main' }}>
      <CardContent>
        <Box display='flex' alignItems='center' gap={1} mb={2}>
          <PersonAddAlt color='warning' />
          <Typography variant='h6' fontWeight='bold'>
            Seus Dados como Responsável
          </Typography>
          <Chip label='Novo cadastro' size='small' color='warning' />
        </Box>

        <Alert severity='info' sx={{ mb: 2 }}>
          Como você é novo no sistema, preencha seus dados abaixo para se
          cadastrar como responsável.
        </Alert>

        {/* ========== DADOS PESSOAIS ========== */}
        <Typography
          variant='subtitle1'
          fontWeight='bold'
          sx={{ mb: 2, mt: 3 }}
        >
          Dados Pessoais do Responsável
        </Typography>

        <Grid container spacing={2}>
          <Grid item lg={6} xs={12}>
            <JumboTextField
              fullWidth
              name='nome_responsavel'
              label='Nome Completo do Responsável *'
              sx={{ background: '#ffffff' }}
            />
          </Grid>

          <Grid item lg={6} xs={12}>
            <JumboTextField
              fullWidth
              name='data_nascimento_responsavel'
              type='date'
              label='Data de Nascimento do Responsável *'
              sx={{ background: '#ffffff' }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item lg={4} xs={12}>
            <InputMask
              mask='999.999.999-99'
              value={values.cpf_responsavel}
              onChange={handleChange}
            >
              {(inputProps) => (
                <JumboTextField
                  {...inputProps}
                  fullWidth
                  name='cpf_responsavel'
                  label='CPF do Responsável *'
                  type='text'
                  sx={{ background: '#ffffff' }}
                />
              )}
            </InputMask>
          </Grid>

          <Grid item lg={4} xs={12}>
            <JumboTextField
              fullWidth
              name='rg_responsavel'
              label='RG do Responsável'
              sx={{ background: '#ffffff' }}
            />
          </Grid>
        </Grid>

        {/* ========== CONTATO ========== */}
        <Typography
          variant='subtitle1'
          fontWeight='bold'
          sx={{ mb: 2, mt: 3 }}
        >
        Contato do Responsável
        </Typography>

        <Grid container spacing={2}>
          <Grid item lg={6} xs={12}>
            <InputMask
              mask='+999(99)99999-9999'
              value={values.celular_responsavel}
              onChange={handleChange}
            >
              {(inputProps) => (
                <JumboTextField
                  {...inputProps}
                  fullWidth
                  name='celular_responsavel'
                  label='Celular do Responsável (DDI, DDD e número) *'
                  sx={{ background: '#ffffff' }}
                  InputLabelProps={{ shrink: true }}
                />
              )}
            </InputMask>
          </Grid>

          <Grid item lg={6} xs={12}>
            <InputMask
              mask='+999(99)99999-9999'
              value={values.celular_responsavel_confirmacao}
              onChange={handleChange}
              onPaste={(e) => e.preventDefault()}
            >
              {(inputProps) => (
                <JumboTextField
                  {...inputProps}
                  fullWidth
                  name='celular_responsavel_confirmacao'
                  label='Confirmar Celular do Responsável *'
                  sx={{ background: '#ffffff' }}
                  InputLabelProps={{ shrink: true }}
                  
                />
              )}
            </InputMask>
          </Grid>

          <Grid item lg={6} xs={12}>
            <JumboTextField
              fullWidth
              name='telefone_responsavel'
              label='Telefone Fixo do Responsável (opcional)'
              sx={{ background: '#ffffff' }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item lg={6} xs={12}>
            <JumboTextField
              fullWidth
              name='email_responsavel'
              label='Email do Responsável *'
              type='email'
              sx={{ background: '#ffffff' }}
            />
          </Grid>

          <Grid item lg={6} xs={12}>
            <JumboTextField
              fullWidth
              name='email_responsavel_confirmacao'
              label='Confirmar Email do Responsável *'
              type='email'
              sx={{ background: '#ffffff' }}
              onPaste={(e) => e.preventDefault()}
            />
          </Grid>
        </Grid>

        {/* ========== ENDEREÇO ========== */}
        <Typography
          variant='subtitle1'
          fontWeight='bold'
          sx={{ mb: 2, mt: 3 }}
        >
          Endereço do Responsável
        </Typography>

        <Grid container spacing={2}>
          <Grid item lg={4} xs={12}>
            <FormControl fullWidth>
              <Select
                options={COUNTRIES}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                onChange={(pais) => {
                  setFieldValue('pais_responsavel', pais.value);
                }}
                value={COUNTRIES.filter(
                  (option) =>
                    option.value === (values.pais_responsavel || 'BR')
                )}
                placeholder='País'
              />
            </FormControl>
          </Grid>

          <Grid item lg={8} xs={12}>
            <Typography variant='body2' color='textSecondary'>
              Escolha o país onde o responsável mora atualmente
            </Typography>
          </Grid>

          {/* ========== ENDEREÇO BRASIL ========== */}
          {values.pais_responsavel === 'BR' && (
            <>
              <Grid item lg={3} xs={12}>
                <InputMask
                  mask='99999-999'
                  value={values.CEP_responsavel}
                  onChange={handleChange}
                  onBlur={(e) => checkCepResp(e, setFieldValue)}
                  disabled={confirmedUserData}
                  disabledUnderline={confirmedUserData}
                >
                  {(inputProps) => (
                    <JumboTextField
                      {...inputProps}
                      fullWidth
                      name='CEP_responsavel'
                      label='CEP do Responsável'
                      sx={{ background: '#ffffff' }}
                      disabled={inputProps.disabledUnderline}
                    />
                  )}
                </InputMask>
              </Grid>

              <Grid item lg={1} xs={1}>
                {isLoading && (
                  <CircularProgress style={{ alignSelf: 'center' }} />
                )}
              </Grid>

              <Grid item lg={6} xs={12}>
                <JumboTextField
                  fullWidth
                  name='endereco_responsavel'
                  label='Endereço do Responsável *'
                  sx={{ background: '#ffffff' }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item lg={3} xs={12}>
                <JumboTextField
                  fullWidth
                  name='numero_responsavel'
                  label='Número *'
                  sx={{ background: '#ffffff' }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <JumboTextField
                  fullWidth
                  name='complemento_responsavel'
                  label='Complemento'
                  sx={{ background: '#ffffff' }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <JumboTextField
                  fullWidth
                  name='bairro_responsavel'
                  label='Bairro *'
                  sx={{ background: '#ffffff' }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item lg={2} xs={6}>
                <FormControl fullWidth>
                  <InputLabel id='uf_responsavel'>UF *</InputLabel>
                  <JumboSelectField
                    labelId='uf_responsavel'
                    name='uf_responsavel'
                    label='UF'
                    sx={{ background: '#ffffff' }}
                  >
                    <MenuItem value='AC'>Acre</MenuItem>
                    <MenuItem value='AL'>Alagoas</MenuItem>
                    <MenuItem value='AP'>Amapá</MenuItem>
                    <MenuItem value='AM'>Amazonas</MenuItem>
                    <MenuItem value='BA'>Bahia</MenuItem>
                    <MenuItem value='CE'>Ceará</MenuItem>
                    <MenuItem value='DF'>Distrito Federal</MenuItem>
                    <MenuItem value='ES'>Espírito Santo</MenuItem>
                    <MenuItem value='GO'>Goiás</MenuItem>
                    <MenuItem value='MA'>Maranhão</MenuItem>
                    <MenuItem value='MT'>Mato Grosso</MenuItem>
                    <MenuItem value='MS'>Mato Grosso do Sul</MenuItem>
                    <MenuItem value='MG'>Minas Gerais</MenuItem>
                    <MenuItem value='PA'>Pará</MenuItem>
                    <MenuItem value='PB'>Paraíba</MenuItem>
                    <MenuItem value='PR'>Paraná</MenuItem>
                    <MenuItem value='PE'>Pernambuco</MenuItem>
                    <MenuItem value='PI'>Piauí</MenuItem>
                    <MenuItem value='RJ'>Rio de Janeiro</MenuItem>
                    <MenuItem value='RN'>Rio Grande do Norte</MenuItem>
                    <MenuItem value='RS'>Rio Grande do Sul</MenuItem>
                    <MenuItem value='RO'>Rondônia</MenuItem>
                    <MenuItem value='RR'>Roraima</MenuItem>
                    <MenuItem value='SC'>Santa Catarina</MenuItem>
                    <MenuItem value='SP'>São Paulo</MenuItem>
                    <MenuItem value='SE'>Sergipe</MenuItem>
                    <MenuItem value='TO'>Tocantins</MenuItem>
                  </JumboSelectField>
                </FormControl>
              </Grid>

              <Grid item lg={2} xs={6}>
                <JumboTextField
                  fullWidth
                  name='cidade_responsavel'
                  label='Cidade *'
                  sx={{ background: '#ffffff' }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </>
          )}

          {/* ========== ENDEREÇO INTERNACIONAL ========== */}
          {values.pais_responsavel !== 'BR' && (
            <>
              <Grid item xs={12}>
                <JumboTextField
                  fullWidth
                  name='endereco_responsavel'
                  label='Endereço Completo do Responsável *'
                  sx={{ background: '#ffffff' }}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <JumboTextField
                  fullWidth
                  name='codigo_postal_responsavel'
                  label='Código Postal *'
                  sx={{ background: '#ffffff' }}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <JumboTextField
                  fullWidth
                  name='estado_responsavel'
                  label='Estado/Província *'
                  sx={{ background: '#ffffff' }}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <JumboTextField
                  fullWidth
                  name='cidade_responsavel'
                  label='Cidade *'
                  sx={{ background: '#ffffff' }}
                />
              </Grid>
            </>
          )}
        </Grid>

        {/* ========== SENHA ========== */}
        <Typography
          variant='subtitle1'
          fontWeight='bold'
          sx={{ mb: 2, mt: 3 }}
        >
          Senha de Acesso do Responsável
        </Typography>

        <Grid container spacing={2}>
          <Grid item lg={6} xs={12}>
            <JumboTextField
              fullWidth
              id='senha_responsavel'
              type={mostrarSenhaResponsavel ? 'text' : 'password'}
              name='senha_responsavel'
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      aria-label='toggle password visibility'
                      onClick={handleClickShowSenhaResponsavel}
                      onMouseDown={handleMouseDownPassword}
                      edge='end'
                    >
                      {mostrarSenhaResponsavel ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{ shrink: true }}
              sx={{ background: '#ffffff' }}
              label='Senha do Responsável *'
            />
          </Grid>

          <Grid item lg={6} xs={12}>
            <JumboTextField
              fullWidth
              id='senha_responsavel_confirmacao'
              type={mostrarSenhaConfirmacaoResponsavel ? 'text' : 'password'}
              name='senha_responsavel_confirmacao'
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      aria-label='toggle password visibility'
                      onClick={handleClickShowSenhaConfirmacaoResponsavel}
                      onMouseDown={handleMouseDownPasswordConfirmation}
                      edge='end'
                    >
                      {mostrarSenhaConfirmacaoResponsavel ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{ shrink: true }}
              sx={{ background: '#ffffff' }}
              label='Confirmar Senha do Responsável *'
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default FormularioResponsavelNovo;
